// Static Data
import { timezones } from './TimezonesData';
import { getUserInfoFromLocalStorage } from '../services/auth';

// ✅ IMPORTS CORRECTOS
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

// FUNCIONES PARA FORMATEAR TIMEZONE.

//funcion para aclarar o oscurecer un color
export const changeLigthColor = (color, amount) => {
    var usePound = false;
    if (color[0] === "#") {
        color = color.slice(1);
        usePound = true;
    }
    var num = parseInt(color, 16);
    var r = (num >> 16) + amount;
    if (r > 255) r = 255;
    else if (r < 0) r = 0;
    var b = ((num >> 8) & 0x00FF) + amount;
    if (b > 255) b = 255;
    else if (b < 0) b = 0;
    var g = (num & 0x0000FF) + amount;
    if (g > 255) g = 255;
    else if (g < 0) g = 0;
    return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
};

// ✅ Obtiene el timezone del usuario con fallback al navegador
const formatGMTuser = () => {
    const tzFromLS = getUserInfoFromLocalStorage()?.info?.tz; // ej: "America/Argentina/Buenos_Aires"
    const tzCandidate =
        (tzFromLS && timezones[tzFromLS]) ? timezones[tzFromLS] :
            tzFromLS;

    // Si viene bien formado, lo usamos
    if (typeof tzCandidate === "string" && tzCandidate.includes("/")) return tzCandidate;

    // Fallback real del navegador
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

// ✅ Parser robusto: epoch secs/ms, ISO con Z u offset, Date
const parseAnyTimestampToDate = (input) => {
    if (input == null || input === "" || input === "-") return null;

    if (input instanceof Date) {
        return Number.isNaN(input.getTime()) ? null : input;
    }

    const isNumeric =
        typeof input === "number" ||
        (typeof input === "string" && /^[0-9]+(\.[0-9]+)?$/.test(input.trim()));

    if (isNumeric) {
        const n = Number(input);
        if (!Number.isFinite(n)) return null;

        // ✅ CHANGED: soporta segundos (1769462246) y también ms
        const ms = n >= 1e12 ? n : n * 1000;

        const d = new Date(ms);
        return Number.isNaN(d.getTime()) ? null : d;
    }

    if (typeof input === "string") {
        const d = new Date(input.trim()); // soporta ...Z y ...-03:00
        return Number.isNaN(d.getTime()) ? null : d;
    }

    return null;
};

// ✅ Convierte a hora del usuario (GENÉRICO para ambos)
// - ISO con offset -> lo convierte/normaliza a formato UI
// - epoch seconds/ms -> lo convierte/normaliza a formato UI
export const utcConverter = (timestampUtc) => {
    if (timestampUtc === '-') return '-';

    const tz = formatGMTuser();
    const date = parseAnyTimestampToDate(timestampUtc);
    if (!date) return '';

    const zonedDate = utcToZonedTime(date, tz);

    // ✅ CHANGED: salida ÚNICA y consistente (con segundos)
    // Si NO querés segundos, cambiá a 'yyyy-MM-dd HH:mm'
    return format(zonedDate, 'yyyy-MM-dd HH:mm:ss', { timeZone: tz });
};

// ✅ Mantengo tu nombre por compatibilidad: ahora soporta epoch + ISO offset
export const millisecondsConverter = (t) => {
    const date = parseAnyTimestampToDate(t);
    if (!date) return null;

    // ✅ CHANGED: devuelve el mismo formato final que utcConverter
    return utcConverter(date);
};
